<div class="card">
  <div class="card-header">
    <h2>{{ 'rule_details' | translate }}</h2>
  </div>
  <div class="card-body">
    <div class="row margin-bottom-lg">
      <div class="col-12" [formGroup]="form">
        <div>
          <span class="fw-bold" [id]="field + '_label'">{{ 'audit_rule_property_rule_id' | translate }}</span>
          <input
            [id]="field + '_input'"
            [attr.aria-labelledby]="field + '_label' + ' ' + field + '_error'"
            type="text"
            class="w-100 form-control form-element"
            [ngbTypeahead]="searchFunction"
            [formControlName]="field"
            (keydown.enter)="onEnter($event)"
            (selectItem)="onSelectItem($event)"
            (blur)="onBlur()"
          />
        </div>
        <div [id]="field + '_error'" class="error-container">
          <app-form-field-error
            [formValidationRequest$]="formValidationRequest$"
            [field]="form.get(field)"
            [name]="field"
            [label]="'audit_rule_property_rule_id'"
            [customMessage]="ruleErrorMessage"
          ></app-form-field-error>
        </div>
      </div>
    </div>

    <div class="row margin-bottom-lg">
      <div class="col-12">
        <h3 class="no-margin-bottom">{{ ruleReport.ruleDescription }}</h3>
      </div>
    </div>
    @if (customSeveritiesData) {
      <div class="row margin-bottom-md">
        <div class="col-md-6 d-flex flex-column">
          <h4 class="label h5">{{ 'audit_rule_property_severity' | translate }}</h4>
          <div class="" data-test-id="rule-info-severity">
            <table-cell-custom-severity
              [config]="{
                severity: this.ruleReport.severity,
                customSeverity: this.customSeveritiesData.get(this.ruleReport.severity),
                customSeverityKeysSortedByRank: this.customSeverityKeysSortedByRank,
              }"
            ></table-cell-custom-severity>
          </div>
        </div>
        <div class="col-md-6 d-flex flex-column" data-test-id="success-criteria">
          <h4 class="label h5">
            {{ 'label_criteria' | translate }}
          </h4>
          <ul class="list-unstyled m-0">
            @for (criteria of successCriterias; track criteria) {
              <li class="d-block">
                {{ criteria }}
              </li>
            }
          </ul>
        </div>
      </div>
    }
    <div class="row margin-bottom-md">
      <div class="col-md-6">
        <h4 class="label h5">{{ 'label_disabilities_affected' | translate }}</h4>
        <ul class="list-unstyled m-0">
          @for (disability of ruleReport.disabilitiesAffected; track disability) {
            <li class="d-block">
              {{ disability | titlecase }}
            </li>
          }
        </ul>
      </div>
      <div class="col-md-6 d-flex flex-column">
        @if (ruleReport.standards.length > 0) {
          <h4 class="label h5">
            {{ 'label_standard' | translate }}
          </h4>
          <ul class="list-unstyled m-0">
            @for (standard of ruleReport.standards; track standard) {
              <li class="d-block">
                {{ standard | translate }}
              </li>
            }
          </ul>
        }
      </div>
    </div>
  </div>
</div>
